export default class DataSetColTimeEditor
{
	name;
    label;
    visible = true;
    helpText = null;
    displayLength = 24;
    alignment = "Center";
    displayFormat = "HH:mm:ss";
    type = "Time";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColTimeEditor.js